import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}

const SvgComponent = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.003 10.834V12.5h10v-1.666h-10Zm-.524-1.667c-.631 0-1.143.448-1.143 1v3c0 .552.512 1 1.143 1h11.047c.632 0 1.143-.448 1.143-1v-3c0-.552-.511-1-1.143-1H4.48Z"
            fill="currentColor"
        />
        <path
            d="M15.003 11.667h1.666v6.667h-1.666v-6.667ZM3.336 11.667h1.667v6.667H3.336v-6.667Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.798 3.14c.098-.84.81-1.473 1.656-1.473h5.096c.845 0 1.557.633 1.655 1.473l.9 7.694H4.898l.9-7.694Zm3.56 2.922 2.311-2.312 1.012 1.012-3.353 3.352-2.064-2.102 1.041-1.04 1.053 1.09Z"
            fill="currentColor"
        />
    </svg>
);

export default SvgComponent;
